<template>
    <div class="DshDaterange">
        <template v-if="['time', 'timerange'].includes(propsObj._dateType)">
            <!-- 时间范围 -->
            <TimePicker
                style="width: 100%;"
                v-model="value[propsObj._key]"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
                :type="getDateTpe(propsObj._dateType)"
                :disabled="!finalCanEdit"
                :clearable="clearable"
                :transfer="true"
                @on-change="change"
            ></TimePicker>
        </template>

        <!-- 动态日期 -->
        <template v-else-if="['date', 'datetime', 'daterange', 'datetimerange', 'year', 'month'].includes(propsObj._dateType)">
            <DatePicker
                class="DshDaterange-left"
                v-model="value[propsObj._key][0]"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
                :type="propsObj._dateType"
                :disabled="!finalCanEdit"
                :clearable="clearable"
                :transfer="true"
                :open="leftDatePickerOpen"
                :options="dynDate | filterOptions(propsObj, 0, clickShortcuts)"
                @on-open-change="onOpenChange($event, 0)"
            >
                <div class="DshDaterange-item">
                    <span
                        class="DshDaterange-item-name"
                        @click="leftDatePickerOpen=true"
                    >
                        <template v-if="isDynNumber(value[propsObj._key][0])">
                            {{ value[propsObj._key][0] | filterName(dynDate) }}
                        </template>
                        <template v-else>
                            {{ value[propsObj._key][0] | dateFormat(format) }}
                        </template>
                    </span>
                    <span class="DshDaterange-item-icon">
                        <Icon
                            v-show="value[propsObj._key][0]"
                            type="md-close"
                            @click="clickShortcuts('', 0)"
                        />
                        <Icon
                            v-show="!value[propsObj._key][0]"
                            type="ios-calendar-outline"
                        />
                    </span>
                </div>
            </DatePicker>
            <span class="DshDaterange-center"> — </span>
            <DatePicker
                class="DshDaterange-right"
                v-model="value[propsObj._key][1]"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
                :type="propsObj._dateType"
                :disabled="!finalCanEdit"
                :clearable="clearable"
                :transfer="true"
                :open="rightDatePickerOpen"
                :options="dynDate | filterOptions(propsObj, 1, clickShortcuts)"
                @on-open-change="onOpenChange($event, 1)"
            >
                <div class="DshDaterange-item">
                    <span
                        class="DshDaterange-item-name"
                        @click="rightDatePickerOpen=true"
                    >
                        <template v-if="isDynNumber(value[propsObj._key][1])">
                            {{ value[propsObj._key][1] | filterName(dynDate) }}
                        </template>
                        <template v-else>
                            {{ value[propsObj._key][1] | dateFormat(format) }}
                        </template>
                    </span>
                    <span class="DshDaterange-item-icon">
                        <Icon
                            v-show="value[propsObj._key][1]"
                            type="md-close"
                            @click="clickShortcuts('', 1)"
                        />
                        <Icon
                            v-show="!value[propsObj._key][1]"
                            type="ios-calendar-outline"
                        />
                    </span>
                </div>
            </DatePicker>
        </template>

        <!-- 年范围，月范围 暂时不用-->
        <!-- <template v-else-if="['year', 'month'].includes(propsObj._dateType)">
            <DatePicker
                class="DshDaterange-left"
                v-model="value[propsObj._key][0]"
                :placeholder="canEdit && propsObj._enterType !== 'calculate' ? `请输入${propsObj._name}` : ''"
                :type="propsObj._dateType"
                :disabled="!finalCanEdit"
                :clearable="true"
                :transfer="true"
                @on-change="change"
            ></DatePicker>
            <span class="DshDaterange-center"> — </span>
            <DatePicker
                class="DshDaterange-right"
                v-model="value[propsObj._key][1]"
                :placeholder="canEdit && propsObj._enterType !== 'calculate' ? `请输入${propsObj._name}` : ''"
                :type="propsObj._dateType"
                :disabled="!finalCanEdit"
                :clearable="true"
                :transfer="true"
                @on-change="change"
            ></DatePicker>
        </template> -->
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshDaterange",
        mixins: [controlMixin],
        props: {},
        data () {
            return {
                getDateTpe (dateType) {
                    if (dateType.endsWith("range")) {
                        return dateType;
                    } else {
                        return `${dateType}range`;
                    }
                },

                leftDatePickerOpen: false,
                rightDatePickerOpen: false,
                dynDate: [
                    { _key: "dyn_now", name: "今天", numbers: [0, 1], dateType: ["date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_today", name: "现在", numbers: [0, 1], dateType: ["date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_yesterday", name: "昨天", numbers: [0], dateType: ["date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_subtract_7_days", name: "七天前", numbers: [0], dateType: ["date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_subtract_30_days", name: "三十天前", numbers: [0], dateType: ["date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_add_7_days", name: "七天后", numbers: [1], dateType: ["date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_add_30_days", name: "三十后", numbers: [1], dateType: ["date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_month_start", name: "月初", numbers: [0], dateType: ["date", "datetime", "daterange", "datetimerange", "month"] },
                    { _key: "dyn_month_end", name: "月末", numbers: [1], dateType: ["date", "datetime", "daterange", "datetimerange", "month"] },
                    { _key: "dyn_year_start", name: "年初", numbers: [0], dateType: ["year", "date", "datetime", "daterange", "datetimerange"] },
                    { _key: "dyn_year_end", name: "年末", numbers: [1], dateType: ["year", "date", "datetime", "daterange", "datetimerange"] }
                ]
            };
        },
        computed: {
            format () {
                let dataTypsFormat = {
                    date: "yyyy-MM-dd",
                    daterange: "yyyy-MM-dd",
                    datetime: "yyyy-MM-dd hh:mm:ss",
                    datetimerange: "yyyy-MM-dd hh:mm:ss",
                    year: "yyyy",
                    month: "yyyy-MM"
                };
                return dataTypsFormat[this.propsObj && this.propsObj._dateType] || dataTypsFormat.date;
            }
        },
        created () {
            this.init();
        },
        methods: {
            init () {
                // 初始化数据，防止动态参数 被 dateRange onchange 事件清除掉
                if (this.value[this.propsObj._key]) {
                    let initData = JSON.parse(JSON.stringify(this.value[this.propsObj._key]));
                    this.$nextTick(() => {
                        initData.forEach((key, idx) => {
                            this.$set(this.value[this.propsObj._key], idx, new Date(key) != "Invalid Date" ? this.$dateFormat(key, "yyyy-MM-dd hh:mm:ss") : key);
                        });
                    });
                }
            },
            change (...params) {
                this.$emit("change", ...params);
            },
            // 点击快捷日期
            clickShortcuts (key, number) {
                this.$set(this.value[this.propsObj._key], number, "");
                this.$nextTick(() => {
                    this.$set(this.value[this.propsObj._key], number, key);
                    this.onOpenChange(false, number);
                });
            },
            onOpenChange (val, number) {
                if (!val) {
                    if (number) {
                        this.rightDatePickerOpen = false;
                    } else {
                        this.leftDatePickerOpen = false;
                    }
                    this.$emit("change", this.value[this.propsObj._key]);
                }
            },
            isDynNumber (val) {
                if (val) {
                    return this.dynDate.some(dynItem => dynItem._key === val);
                } else {
                    return true;
                }
            }
        },
        filters: {
            filterOptions (dynDate, propsObj, number, clickFun) {
                return {
                    shortcuts: dynDate
                        .filter(dynItem => dynItem.numbers.includes(number) && dynItem.dateType.includes(propsObj._dateType))
                        .map(dynItem => ({ text: dynItem.name, onClick: () => clickFun(dynItem._key, number) }))
                };
            },
            filterName (val, dynDate) {
                let findOne = dynDate.find(dynItem => dynItem._key === val);
                return findOne ? findOne.name : val;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshDaterange.vue